export default class Validator
{
    static expressions() {

        return {
            integer : /^\d+$/,
            email   : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            url     : /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
        }
    }

    constructor(rules, messages)
    {
        this.errors    = {};
        this.rules     = rules || {};
        this.defaults  = {
            messages : {
                required : 'Required field',
                email    : 'Invalid email'
            }
        };

        this.messages = _.merge(this.defaults.messages, messages || {});
    }

    validate(model){

        this.reset();

        for (let key in this.rules){

            let value = null;
            let rule  = this.rules[key];

            if( key.indexOf('.') !== -1 ){

                let parts = key.split('.');
                let obj   = model.getKeyValue(parts[0]);

                if(obj){

                    value = obj.getKeyValue(parts[1]);
                }

            } else {

                value = model.getKeyValue(key);
            }

            if(rule.required && !value){

                this.errors[key] = this.messages.required ;

            } else if (value){

                let valid  = false;

                switch (rule.type) {

                    case 'email':   valid = Validator.isValidEmail(value,   rule.options || {} ); break;
                    case 'url':     valid = Validator.isValidUrl(value,     rule.options || {} ); break;
                    case 'integer': valid = Validator.isValidInteger(value, rule.options || {} ); break;
                    case 'string':  valid = Validator.isValidString(value,  rule.options || {} ); break;
                    case 'object':  valid = typeof value === 'object';                                    break;
                }

                if (!valid) {

                    this.errors[key] = this.messages[key] || this.messages[rule.type];
                }
            }
        }

        return this;
    }

    getErrors()
    {
        return this.errors;
    }

    getError(key){

        return this.hasError(key) ? this.errors[key] : null;
    }

    hasError(key){

        return this.errors[key] !== undefined;
    }

    hasErrors()
    {
        return _.size( this.errors) > 0;
    }

    addError(key, message)
    {
        this.errors[key] = message;
    }

    reset()
    {
        this.errors = {};
    }

    static isValidString(value, options)
    {
        let length = true;

        if(options) {

            if(options.min !== undefined ){

                length = value.length >= parseInt(options.min);
            }

            if(options.max !== undefined && options.max ){

                length = value.length <= parseInt(options.max);
            }
        }

        return value && length ? true : false;
    }

    static isValidInteger(value, options){

        let length = true;

        if(options) {

            if(options.min !== undefined ){

                length = parseInt(value) >= parseInt(options.min);
            }

            if(options.max !== undefined ){

                length = parseInt(value) <= parseInt(options.max);
            }
        }

        return length && Validator.expressions().integer.test(value);
    }

    static isValidEmail(value, options) {

        return Validator.expressions().email.test(String(value).toLowerCase());
    }

    static isValidUrl(value, options) {

        return Validator.expressions().url.test(String(value).toLowerCase());
    }
}



// WEBPACK FOOTER //
// ./resources/js/core/Validator.js